import { CloseIcon } from 'client/components/common/icons';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  title: string;
  onClose?: () => void;
  onClear?: (() => void) | null;
  dataTestId?: string;
} & React.HTMLProps<HTMLDivElement>;

export const Modal = ({ children, title, onClear, onClose, dataTestId, ...rest }: Props) => {
  return (
    <div className="fixed top-0 left-0 h-full z-50" data-testid={dataTestId} {...rest}>
      <div className="bg-black opacity-50 h-full w-screen" />
      <div className="absolute overflow-y-auto bg-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full">
        <div className="top-0 left-0 flex items-center justify-between w-full bg-white sticky py-4 px-5 border-b-[0.6px] border-solid border-gray">
          <div
            className={`cursor-pointer ${!onClose && 'invisible'}`}
            onClick={onClose}
            data-testid="modal-close-button"
            aria-label="モーダルを閉じるボタン"
          >
            <CloseIcon width={12} height={15} />
          </div>
          <div className={`${onClear ? 'ml-6' : 'mx-auto'}`}>
            <p className="text-light-black font-bold text-center" data-testid="modal-title">
              {title}
            </p>
          </div>

          {onClear ? (
            <div>
              <p
                className="text-green text-sm font-bold cursor-pointer"
                onClick={onClear}
                data-testid="modal-reset-button"
              >
                リセット
              </p>
            </div>
          ) : null}
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};
